import { useEffect, useState, useContext, useCallback, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import './login.less';
import { LoginContext } from '@/context/LoginContext';
import { setToken } from '@/utils/cookie.js';
import GoogleImg from '@/assets/layouts/account/google.png';
import EmailImg from '@/assets/layouts/account/email.png';
// import LogoImg from '@/assets/layouts/account/logotype.png';
import TextureNoise from '@/assets/logo.png';
import { authService } from '@/api/index';
import message from '@/utils/message';
// import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import Turnstile from 'react-turnstile';
// Add utility functions for mobile detection and rem conversion
import { useTranslation } from 'react-i18next';
import user from '@/assets/user.json';
const isMobileDevice = () => {
  return (
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
    window.innerWidth < 766
  ); // Common breakpoint for mobile devices
};

// Function to convert px to rem for mobile devices only
const mobileRem = (px) => {
  if (isMobileDevice()) {
    // Base font size is typically 16px, adjust according to your design
    return `${px / 16}rem`;
  }
  return `${px}px`; // Return px value for desktop
};

// Hook to handle responsive sizing
const useResponsiveSizing = () => {
  const [isMobile, setIsMobile] = useState(isMobileDevice());

  useEffect(() => {
    const handleResize = () => {
      console.log(isMobileDevice(), 'isMobileDevice()');
      if (isMobileDevice()) {
        // You can adjust the base font size calculation based on device width
        // setTimeout(() => {
        const fontSize = document.documentElement.clientWidth / 375; // 375px is typical design width for mobile
        document.documentElement.style.fontSize = `${fontSize}px`;
        // });
      } else {
        // setTimeout(() => {
        document.documentElement.style.fontSize = `16px`;
        // });
      }
      setIsMobile(isMobileDevice());
    };
    if (isMobile) {
      // You can adjust the base font size calculation based on device width
      // setTimeout(() => {
      const fontSize = document.documentElement.clientWidth / 375; // 375px is typical design width for mobile
      document.documentElement.style.fontSize = `${fontSize}px`;
      // });
    } else {
      // setTimeout(() => {
      document.documentElement.style.fontSize = `16px`;
      // }, 50);
    }
    window.addEventListener('resize', handleResize);
    message.close();
    // Set initial font size for root element if mobile

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return { isMobile, mobileRem };
};

export default function Login() {
  const { loginShowType } = useContext(LoginContext);
  const { isMobile } = useResponsiveSizing();
  useEffect(() => {
    document.body.classList.toggle('mobile-device', isMobile);
  }, [isMobile]);
  useEffect(() => {
    sessionStorage.removeItem('register');
  }, []);

  return (
    <div className={`${isMobile ? 'mobile' : 'loginBox'}`}>
      {loginShowType === 0 && (
        <div className="account_header_logo">
          <img
            src={TextureNoise}
            alt=""
            onClick={() => {
              location.href = 'https://www.talecast.ai';
            }}
          />
        </div>
      )}

      <div style={{ display: loginShowType === 0 ? 'block' : 'none' }}>
        <SelectLoginType isMobile={{ isMobile }} />
      </div>
      <div style={{ display: loginShowType === 1 ? 'block' : 'none' }}>
        <EmailLogin isMobile={{ isMobile }} />
      </div>
      <div style={{ display: loginShowType === 2 ? 'block' : 'none' }}>
        <EmailCode isMobile={{ isMobile }} />
      </div>
      {/* {loginShowType === 0 &&}
      {loginShowType === 1 && <EmailLogin isMobile={{ isMobile }} />}
      {loginShowType === 2 && <EmailCode isMobile={{ isMobile }} />} */}
    </div>
  );
}

function SelectLoginType() {
  const { t } = useTranslation();
  // const { isMobile } = useResponsiveSizing();
  const { setLoginShowType } = useContext(LoginContext);
  const queryString = window.location.search;
  const googleLoginUri = `${location.origin}/api/oauth/google`;
  const obj = {};
  obj.utm_source = sessionStorage.getItem('source');
  obj.utm_campaign = sessionStorage.getItem('campaign');
  obj.utm_term = sessionStorage.getItem('term');
  obj.utm_ad = sessionStorage.getItem('ad');
  obj.recall = sessionStorage.getItem('recall');
  obj.redirectUri = window.location.protocol + '//' + window.location.host;
  if (sessionStorage.getItem('feature')) {
    obj.path = 'tool';
  }

  const searchParams = new URLSearchParams(queryString);
  for (const [key, value] of searchParams) {
    obj[key] = value;
  }
  const state = btoa(encodeURIComponent(JSON.stringify(obj)));
  // 谷歌登录初始化
  const loadGoogleSignInScript = useCallback(() => {
    const script = document.createElement('script');
    script.src = 'https://accounts.google.com/gsi/client';
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);
    script.onload = () => {
      initializeGoogleSignIn();
    };
  }, []);

  useEffect(() => {
    loadGoogleSignInScript();
  }, [loadGoogleSignInScript]);

  // 初始化 Google 登录逻辑或设置回调
  const initializeGoogleSignIn = () => {
    console.log('Google GSI script loaded.');
  };

  const handleGoogleLogin = () => {
    // 使用新的 OAuth 2.0 code 模式
    window.google.accounts.oauth2
      .initCodeClient({
        client_id: '375782144745-60viikk2fg5g49n6i85qcd2lsk0fpkol.apps.googleusercontent.com',
        scope: 'openid profile email',
        ux_mode: 'popup', // 或 "redirect"
        callback: (response) => {
          console.log('授权码 code:', response.code);
          if (response.code) {
            document.cookie = 'test=value';
            // 👉 把 code 发给你后端去换 token
            window.location.href = '/api/oauth/google?code=' + response.code + '&state=' + state;
            // fetch('/api/oauth/google?code=' + response.code + '&state=' + state, {
            //   method: 'GET',
            //   headers: { 'Content-Type': 'application/json', Cookie: 'a=1' },
            // });
          }
        },
      })
      .requestCode();
  };

  // const handleGoogleLogin = () => {

  //   // document.querySelector('.g_id_signin div[role="button"]').click();
  // };
  const handleEmailLogin = () => {
    setLoginShowType(1);
  };
  return (
    <div className="select_login_type_box">
      <div className="title_info">{t('As_Login&SignupPage_CTA')}</div>
      <div className="btn_box">
        {/*<div className="diy_google_btn_box" onClick={(e) => e.stopPropagation()}>*/}
        {/*  <button className="diy_google_btn" onClick={(e) => e.stopPropagation()}>*/}
        {/*    <img src={GoogleImg} alt="Google" />*/}
        {/*    <span>{t('As_Login&SignupPage_LoginChoice1')}</span>*/}
        {/*  </button>*/}
        {/*  <div*/}
        {/*    id="g_id_onload"*/}
        {/*    data-auto_prompt="true"*/}
        {/*    data-auto_select="false"*/}
        {/*    data-client_id="375782144745-60viikk2fg5g49n6i85qcd2lsk0fpkol.apps.googleusercontent.com"*/}
        {/*    data-context="use"*/}
        {/*    data-ux_mode="redirect"*/}
        {/*    data-skip_prompt_cookie="talecast_token"*/}
        {/*    data-login_uri={googleLoginUri}*/}
        {/*    data-state={state}*/}
        {/*    data-cancel_on_tap_outside="true"*/}
        {/*    className="custom_google_btn"*/}
        {/*    data-itp_support="true"></div>*/}
        {/*  <div*/}
        {/*    id="googleDom"*/}
        {/*    className="g_id_signin custom-google-signin google_btn"*/}
        {/*    data-type="standard"*/}
        {/*    data-shape="rectangular"*/}
        {/*    data-theme="outline"*/}
        {/*    data-text="signin_with"*/}
        {/*    data-size="large"*/}
        {/*    data-logo_alignment="center"*/}
        {/*    data-border="none"*/}
        {/*    data-click_listener="onClickHandler"></div>*/}
        {/*</div>*/}
        {/* <button className="email_btn" onClick={handleEmailLogin}>
          <img src={GoogleImg} alt="Google" />
          <span>{t('As_Login&SignupPage_LoginChoice1')}</span>
        </button> */}
        <div className="diy_google_btn_box" onClick={handleGoogleLogin}>
          <button className="diy_google_btn">
            <img src={GoogleImg} alt="Google" />
            <span>{t('As_Login&SignupPage_LoginChoice1')}</span>
          </button>
          {/* <div
            id="g_id_onload"
            data-auto_prompt="true"
            data-auto_select="false"
            data-client_id="375782144745-60viikk2fg5g49n6i85qcd2lsk0fpkol.apps.googleusercontent.com"
            data-context="use"
            data-ux_mode="redirect"
            data-skip_prompt_cookie="talecast_token"
            data-login_uri={googleLoginUri}
            data-state={state}
            data-cancel_on_tap_outside="true"
            className="custom_google_btn"
            data-itp_support="true"></div>
          <div
            id="googleDom"
            className="g_id_signin custom-google-signin google_btn"
            data-type="standard"
            data-shape="rectangular"
            data-theme="outline"
            data-text="signin_with"
            data-size="large"
            data-logo_alignment="center"
            data-border="none"
            data-click_listener="onClickHandler"></div> */}
        </div>

        <button
          className="email_btn"
          style={{ backgroundColor: '#A0F00F', border: 'none' }}
          onClick={handleEmailLogin}>
          <img src={EmailImg} alt="Google" />
          <span>{t('As_Login&SignupPage_LoginChoice2')}</span>
        </button>
        <div className="tail">
          By continuing, you agree to{' '}
          <span
            style={{ color: '#A0F00F', cursor: 'pointer' }}
            onClick={() => {
              window.open('https://texturenoise.com/terms-of-use', '_black');
            }}>
            Terms of Use⁠.
          </span>
          <br />
          Read our 
          <span
            style={{ color: '#A0F00F', cursor: 'pointer' }}
            onClick={() => {
              window.open('https://texturenoise.com/privacy-policy', '_black');
            }}>
            Privacy Policy⁠⁠.
          </span>
        </div>
      </div>
      {/*<div className="text_info">*/}
      {/*  {isMobile ? (*/}
      {/*    <>*/}
      {/*      {t('As_Login&SingupPage_AgreementReminder')}{' '}*/}
      {/*      <span*/}
      {/*        onClick={() => {*/}
      {/*          // 使用条款*/}
      {/*          window.open('https://addsubtitle.ai/privacy-policy-and-use-terms', '_black');*/}
      {/*        }}>*/}
      {/*        {t('As_Login&SingupPage_TermofUse')}.*/}
      {/*      </span>*/}
      {/*      {t('As_Login&SingupPage_ReadInstruction')}{' '}*/}
      {/*      <span*/}
      {/*        onClick={() => {*/}
      {/*          // 隐私协议*/}
      {/*          window.open('https://addsubtitle.ai/privacy-policy-and-use-terms', '_black');*/}
      {/*        }}>*/}
      {/*        {t('As_Login&SignupPage_PrivPolicy')}*/}
      {/*      </span>*/}
      {/*    </>*/}
      {/*  ) : (*/}
      {/*    <>*/}
      {/*      {t('As_Login&SingupPage_AgreementReminder')}{' '}*/}
      {/*      <span*/}
      {/*        onClick={() => {*/}
      {/*          // 使用条款*/}
      {/*          window.open('https://addsubtitle.ai/privacy-policy-and-use-terms', '_black');*/}
      {/*        }}>*/}
      {/*        {t('As_Login&SingupPage_TermofUse')}.*/}
      {/*      </span>*/}
      {/*      <br />*/}
      {/*      {t('As_Login&SingupPage_ReadInstruction')}{' '}*/}
      {/*      <span*/}
      {/*        onClick={() => {*/}
      {/*          // 隐私协议*/}
      {/*          window.open('https://addsubtitle.ai/privacy-policy-and-use-terms', '_black');*/}
      {/*        }}>*/}
      {/*        {t('As_Login&SignupPage_PrivPolicy')}*/}
      {/*      </span>*/}
      {/*    </>*/}
      {/*  )}*/}
      {/*</div>*/}
    </div>
  );
}

function EmailLogin() {
  const { t } = useTranslation();
  const { isMobile } = useResponsiveSizing();
  const {
    loginShowType,
    setLoginShowType,
    email,
    setEmail,
    setBeginCountdown,
    setCountdownNum,
    countdownNum,
  } = useContext(LoginContext);
  const [warningText, setWarningText] = useState('');
  const [emailCheck, setEmailCheck] = useState(false);
  const [loading, setloading] = useState(false);
  // const { executeRecaptcha } = useGoogleReCaptcha();

  const handleInputEmail = (val) => {
    setEmailCheck(false);
    setWarningText('');
    setEmail(val.target.value);
  };
  const handleEnterPress = (e) => {
    if (e.key === 'Enter' && loginShowType === 1) {
      handleSubmit();
    }
  };
  // 创建全局键盘回车事件监听
  useEffect(() => {
    document.addEventListener('keydown', handleEnterPress);
    return () => {
      document.removeEventListener('keydown', handleEnterPress);
    };
  }, [loginShowType, email]);
  const handleCheckEmail = () => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailRegex.test(email) && email) {
      setEmailCheck(true);
      setWarningText(t('As_Login&SignupPage_InvalidEmailAddressReminder'));
      return false;
    }
    if (emailCheck && email) {
      setEmailCheck(false);
      setWarningText('');
    }
    return true;
  };

  const handliContinue = async () => {
    // if (!cloudFlareToken) return;
    setloading(true);
    try {
      setCountdownNum(60);
      setBeginCountdown(Date.now());
      setLoginShowType(2);
      sessionStorage.setItem('loginEmail', email);
    } catch (error) {
      if (!error) return;
      console.log(error);
      console.log(error);
      const err = JSON.parse(error);
      // console.log(err);
      // if (err.code === -109) {
      //   setLoginShowType(2);
      //   if (countdownNum < 60 && countdownNum > 0) {
      //     setBeginCountdown(Date.now());
      //   } else {
      //     setCountdownNum(0);
      //   }
      //   // message.warning(`You've reached the maximum attemp`, {
      //   //   isMobile,
      //   // });
      // }
      if (err.code === -112) {
        message.warning(`Verification failed`, {
          isMobile,
        });
      }
    }
    setloading(false);
  };

  // 返回选择登录方式
  const handleBack = () => {
    setLoginShowType(0);
  };

  // 处理表单提交
  const handleSubmit = async () => {
    if (loading) return;
    if (!handleCheckEmail()) return;
    if (!email) {
      setEmailCheck(true);
      setWarningText(t('As_Login&SignupPage_InvalidEmailAddressReminder'));
      return;
    }
    // 如果在倒计时当中就不需要获取接口直接进入验证码页面
    if (countdownNum < 60 && countdownNum > 0 && email === sessionStorage.getItem('loginEmail')) {
      setBeginCountdown(Date.now());
      setLoginShowType(2);
      return;
    }

    sendEmailCode();
    // if (!executeRecaptcha) {
    //   console.log('reCAPTCHA 尚未准备好');
    //   return;
    // }
  };

  const sendEmailCode = async () => {
    const res = await authService.authEmailCode({
      email,
      language: localStorage.getItem('i18nextLng') || 'en',
    });
    console.log(res);
    if (res.code === 0) {
      handliContinue();
    } else {
      message.warning(`Send failed`, {});
    }
  };
  return (
    <div className="email_login_box">
      <div className="back_box" onClick={handleBack}>
        &lt; {t('As_Login&SignupPage_Backward')}
      </div>
      <div className="title">Enter email</div>
      <div className="title_info">
        We’ll check if you have an account, and help create one if you don’t.
      </div>
      <input
        type="email"
        value={email}
        placeholder={t('As_Login&SignupPage_VerifyEmail')}
        onInput={handleInputEmail}
        onBlur={handleCheckEmail}
        name="email"
        autoComplete="email"
        className={`email_ipt  ${emailCheck && 'email_ipt_error'}`}
      />
      <div className="warning_text">{emailCheck && warningText}</div>
      <button
        // disabled={!cloudFlareToken}
        className="btn btn-primary continue_btn"
        onClick={handleSubmit}>
        {loading && <span className="loading loading-spinner loading-sm"></span>}
        {t('As_Login&SignupPage_Proceeding')}
      </button>
    </div>
  );
}

function EmailCode() {
  const { t } = useTranslation();
  const { isMobile } = useResponsiveSizing();
  const navigate = useNavigate();
  // const { executeRecaptcha } = useGoogleReCaptcha();
  const {
    loginShowType,
    setLoginShowType,
    email,
    setEmailCode,
    countdownNum,
    setCountdownNum,
    setBeginCountdown,
  } = useContext(LoginContext);
  const [warningText, setWarningText] = useState('');
  const [codeChars, setCodeChars] = useState(Array(6).fill(''));
  const [emailCodeCheck, setEmailCodeCheck] = useState(false);
  const [isComposing, setIsComposing] = useState(false); // 添加中文输入法合成状态跟踪
  const [loading, setLoading] = useState(false);
  const [resendLoading, setResendLoading] = useState(false);
  const [cloudFlareCodeKey, setCloudFlareCodeKey] = useState(0);
  const [cloudFlareCodeShow, setCloudFlareCodeShow] = useState(false);

  // 创建对输入框的引用
  const inputRefs = useRef([]);
  const length = 6; // 添加length变量，因为原代码中有使用但未定义

  // 初始化refs数组
  useEffect(() => {
    if (loginShowType === 2) {
      inputRefs.current = inputRefs.current.slice(0, 6);
      // 处理自动聚焦
      if (inputRefs.current[0]) {
        inputRefs.current[0].focus();
      }
    }
  }, [loginShowType]);
  const isCodeComplete = () => {
    return codeChars.every((char) => char !== '');
  };

  useEffect(() => {
    const completeCode = codeChars.join('');
    setEmailCode(completeCode);
    if (isCodeComplete() && completeCode.length === 6) {
      console.log('提交验证码');
      setLoading(true);
      // const Number = new Date().getHours();
      // const canLoginUser = user.find((res) => res.time.includes(Number));
      // const canLogin = canLoginUser?.email === email && canLoginUser?.code === completeCode;
      // const canLogin = user.find((res) => res.email === email && res.code === completeCode);
      // if (canLogin) {
      //   localStorage.setItem('useEmail', email);
      //   navigate('/home');
      // } else {
      //   message.warning('The user does not exist');
      // }
      setLoading(false);
      submitLoginInfo(completeCode);
    }
  }, [codeChars]);

  useEffect(() => {
    if (loading) {
      inputRefs.current.forEach((ref) => {
        if (ref) {
          ref.blur(); // 使每个输入框失去焦点
        }
      });
    }
  }, [loading]);

  const submitLoginInfo = async (val) => {
    if (loading) return;
    setLoading(true);

    try {
      const res = await authService.newLogin({
        email,
        captchaCode: val,
        recall: sessionStorage.getItem('recall') || null,
      });

      if (res.code === 0) {
        setToken(res.data.token);
        sessionStorage.removeItem('recall');
        navigate('/home');
        console.log('1111');
        if (res.data.register) {
          if (window.onClickGATrackEvent) {
            window.onClickGATrackEvent('signup-mail-success');
          }
        } else {
          if (window.onClickGATrackEvent) {
            window.onClickGATrackEvent('login-mail-success');
          }
        }
        console.log('2222');
      }
    } catch (error) {
      const err = JSON.parse(error);
      console.log(err);
      if (err.code === -3) {
        setEmailCodeCheck(true);
        setWarningText(t('As_Login&SignupPage_IncorrectCodeReminder'));
      }
      if (err.code === -110) {
        setEmailCodeCheck(true);
        setWarningText(t('As_Login&SignupPagfe_CodeexpiredReminder'));
      }
    }
    setLoading(false);
  };

  const validateInput = (value) => {
    return /^[a-zA-Z0-9]*$/.test(value);
  };
  // 添加中文输入法合成事件处理
  // const handleCompositionStart = () => {
  //   setIsComposing(true);
  // };

  // const handleCompositionEnd = () => {
  //   setIsComposing(false);
  // };
  const handleInputChange = (index, event) => {
    setEmailCodeCheck(false);
    setWarningText('');
    const { value } = event.target;
    const isDirectChar = /[a-zA-Z0-9]/.test(value);

    // 如果当前在组合状态，但检测到了直接输入字符
    if (isComposing && isDirectChar) {
      setIsComposing(false);
      return;
    }
    // if (isComposing) {
    //   return;
    // }

    // 处理多字符输入（例如从剪贴板复制粘贴到单个输入框）
    if (value.length > 1) {
      const chars = value.split('');
      const newCodeChars = [...codeChars];

      // 只保留有效字符
      const validChars = chars.filter((char) => validateInput(char));

      // 填充验证码
      for (let i = 0; i < validChars.length && index + i < length; i++) {
        newCodeChars[index + i] = validChars[i];
      }

      setCodeChars(newCodeChars);

      // 聚焦到最后填充的格子之后
      const nextIndex = Math.min(index + validChars.length, length - 1);
      setTimeout(() => {
        inputRefs.current[nextIndex]?.focus();
      }, 0);

      return;
    }

    // 单字符处理
    const lastChar = value.slice(-1);

    // 验证输入
    if (lastChar && !validateInput(lastChar)) {
      return;
    }

    // 更新当前位置的字符
    const newCodeChars = [...codeChars];
    newCodeChars[index] = lastChar.toUpperCase();
    setCodeChars(newCodeChars);

    // 如果输入了字符且不是最后一格，自动跳到下一格
    if (lastChar && index < length - 1) {
      // 使用setTimeout确保在DOM更新后再聚焦
      setTimeout(() => {
        if (inputRefs.current[index + 1]) {
          inputRefs.current[index + 1].focus();
        }
      }, 10);
    }
  };

  const handleKeyDown = (index, event) => {
    // 处理退格键
    if (event.key === 'Backspace') {
      const newCodeChars = [...codeChars];

      // 如果当前输入框有值，清空它
      if (newCodeChars[index]) {
        newCodeChars[index] = '';
        setCodeChars(newCodeChars);
        setEmailCodeCheck(false);
        setWarningText('');
      }
      // 如果当前输入框为空且不是第一个，返回上一个
      else if (index > 0) {
        setTimeout(() => {
          if (inputRefs.current[index - 1]) {
            newCodeChars[index - 1] = '';
            setCodeChars(newCodeChars);
            inputRefs.current[index - 1].focus();
          }
        }, 10);
      }
    }

    // 支持左右箭头键导航
    if (event.key === 'ArrowLeft' && index > 0) {
      if (!inputRefs.current[index - 1].value) {
        return;
      }
      setTimeout(() => {
        inputRefs.current[index - 1]?.focus();
      }, 10);
    }

    if (event.key === 'ArrowRight' && index < length - 1) {
      if (!inputRefs.current[index + 1].value) {
        if (!inputRefs.current[index].value) {
          return;
        }
      }
      setTimeout(() => {
        inputRefs.current[index + 1]?.focus();
      }, 10);
    }
  };

  const handlePaste = (startIndex, event) => {
    event.preventDefault();
    const pasteData = event.clipboardData.getData('text').trim();

    // 根据类型过滤粘贴的内容
    const filteredChars = pasteData.replace(/[^a-zA-Z0-9]/g, '');

    // 填充验证码
    const newCodeChars = [...codeChars];
    for (let i = 0; i < filteredChars.length && startIndex + i < length; i++) {
      newCodeChars[startIndex + i] = filteredChars[i].toUpperCase();
    }
    setCodeChars(newCodeChars);

    // 焦点设置到最后一个填充的输入框之后
    const nextFocusIndex = Math.min(startIndex + filteredChars.length, length - 1);
    setTimeout(() => {
      if (inputRefs.current[nextFocusIndex]) {
        inputRefs.current[nextFocusIndex].focus();
      }
    }, 10);
  };

  const getInputMode = () => {
    return 'text';
  };

  const getInputPattern = () => {
    return '[a-zA-Z0-9]*';
  };
  // 返回邮箱输入
  const handleBack = () => {
    setLoginShowType(1);
    setCodeChars(Array(6).fill(''));
    setEmailCodeCheck(false);
    setWarningText('');
  };
  const handleShowCloudflare = () => {
    setCloudFlareCodeShow(true);
  };
  const handleResendNum = async (token) => {
    console.log('handleResendNum====');
    if (resendLoading) return;
    setResendLoading(true);
    console.log('handleResendNum2====');

    try {
      console.log('handleResendNum3====');

      const res = await authService.authEmailCode({
        email,
        language: localStorage.getItem('i18nextLng') || 'en',
      });
      console.log('handleResendNum4====');

      console.log(res);
      if (res.code === 0) {
        setCountdownNum(60);
        setBeginCountdown(Date.now());
        message.success(t('As_Login&SignupPage_CodeCorrectlyConfirmed'), {
          isMobile,
        });
      }
    } catch (error) {
      const err = JSON.parse(error);
      console.log(err);
      // if (err.code === -109) {
      //   message.warning(t('As_LoginSignupPage_MaxnumAttemptReminder'), {
      //     isMobile,
      //   });
      // }
    }
    setResendLoading(false);
  };

  return (
    <div className="email_code_box">
      <div className="btn_box">
        {!isMobile && (
          <div className="back_box" onClick={handleBack}>
            &lt; {t('As_Login&SignupPage_Backward')}
          </div>
        )}
      </div>
      <div className="title">{t('As_Login&SignupPage_Logincompleted')}</div>
      <div className="title_info">
        {t('As_Login&SignupPage_ConfirmLogin1')}&nbsp;<span>{email}</span>, you’ll be all logged in.
      </div>
      <div className="verification_code_container">
        {codeChars.map((char, index) => (
          <input
            key={index}
            ref={(el) => (inputRefs.current[index] = el)}
            type="text"
            disabled={loading}
            className={`code_input ${emailCodeCheck && 'code_err'}`}
            inputMode={getInputMode()}
            pattern={getInputPattern()}
            // onCompositionStart={handleCompositionStart}
            // onCompositionEnd={handleCompositionEnd}
            maxLength={1}
            value={char}
            onMouseDown={(e) => {
              const firstEmptyIndex = codeChars.findIndex((char) => char === '');
              if (firstEmptyIndex !== -1 && inputRefs.current[firstEmptyIndex]) {
                inputRefs.current[firstEmptyIndex].focus();
              }
              if (index !== 0 && !e.target.value) {
                e.preventDefault(); // 阻止默认行为
              }
            }}
            style={{ caretColor: 'transparent' }} // 隐藏输入框光标
            onChange={(e) => handleInputChange(index, e)}
            onKeyDown={(e) => handleKeyDown(index, e)}
            onPaste={(e) => handlePaste(index, e)}
            // aria-label={`Verification code digit ${index + 1}`}
          />
        ))}
      </div>
      <div className="warning_text">{emailCodeCheck && warningText}</div>
      {cloudFlareCodeShow && (
        <Turnstile
          key={cloudFlareCodeKey}
          sitekey="0x4AAAAAABOHiJKKWVOanl63"
          language={localStorage.getItem('i18nextLng')} // 语言代码
          theme="auto"
          size="flexible"
          onLoad={() => console.log('Turnstile 已加载')}
          onError={(error) => {
            console.error('Turnstile 错误:', error);
            setCloudFlareCodeKey(Date.now());
            setCloudFlareCodeShow(true);
          }}
          onExpire={() => {
            console.log('Turnstile 过期');
            setCloudFlareCodeKey(Date.now());
            setCloudFlareCodeShow(true);
          }}
          onVerify={(token) => {
            setCloudFlareCodeShow(false);
            handleResendNum(token);
          }}
        />
      )}
      <div className="resend">
        {countdownNum > 0 && (
          <>
            <div className="countdown_text">
              {t('As_Login&SignupPage_ConfirmLogin2')}
              {t('As_Login&SignupPage_Resend2')}{' '}
              <span className="countdown-num" style={{ color: '#A0F00F', paddingRight: 5 }}>
                {countdownNum}
              </span>
              {t('As_Login&SignupPage_ResendTimeLim')}
            </div>
            {isMobile && (
              <div className="back_box" onClick={handleBack}>
                &lt; {t('As_Login&SignupPage_Backward')}
              </div>
            )}
          </>
        )}
        {countdownNum <= 0 &&
          (isMobile ? (
            <>
              <div className="resend_text">
                {t('As_Login&SignupPage_ConfirmLogin2')}
                <span onClick={handleResendNum}>{t('As_Login&SignupPage_Resend')}</span>
              </div>
              <div className="back_box" onClick={handleBack}>
                &lt; {t('As_Login&SignupPage_Backward')}
              </div>
            </>
          ) : (
            <div className="resend_text">
              {t('As_Login&SignupPage_ConfirmLogin2')}
              <span
                onClick={handleResendNum}
                style={{ color: '#a0f00f', cursor: 'pointer', paddingLeft: '5px' }}>
                {t('As_Login&SignupPage_Resend')}
              </span>
            </div>
          ))}
      </div>
    </div>
  );
}
